import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentMethod } from '../../../../../core/enums/commerce/payment/payment-method';
import { CreditCardSummary } from '../../../../../core/models/commerce/cards-on-file/credit-card-summary';
import { FormGroupType } from '../../../../../core/models/form-group-type';
import { CreditCardSummaryService } from '../../../../../core/services/commerce/credit-card-summary/credit-card-summary.service';
import { PaymentMethodValidatorMap } from '../../shared/constants/payment-method-validator-map';
import { PaymentSourceFormService } from '../../shared/services/payment-source-form/payment-source-form.service';
import { notExpiredValidator } from '../../shared/validators/order-payment-validators';
import { PreferredPaymentMethodFormModel } from '../models/preferred-payment-method-form-model';

@Injectable({
    providedIn: 'root',
})
export class PreferredPaymentMethodFormService extends PaymentSourceFormService<PreferredPaymentMethodFormModel> {
    constructor(
        private readonly creditCardSummaryService: CreditCardSummaryService,
    ) {
        super();
    }

    getFormDefinition(): FormGroup<
        FormGroupType<PreferredPaymentMethodFormModel>
    > {
        return new FormGroup<FormGroupType<PreferredPaymentMethodFormModel>>({
            paymentMethod: new FormControl<PaymentMethod | null>(
                null,
                Validators.required,
            ),
            cardOnFileId: new FormControl<number | null>(null),
        });
    }

    protected getPaymentMethodValidatorMap(
        getCreditCards: () => CreditCardSummary[],
    ): PaymentMethodValidatorMap<PreferredPaymentMethodFormModel> {
        return {
            [PaymentMethod.AuthNetAim]: {
                cardOnFileId: [
                    Validators.required,
                    notExpiredValidator(
                        getCreditCards,
                        this.creditCardSummaryService.isExpired,
                    ),
                ],
            },
            [PaymentMethod.InvoiceNet30]: {
                cardOnFileId: [],
            },
        };
    }
}
